import axios from 'axios';
import {
  DialerCampaign,
  DialerCampaignContactInput,
  DialerPool,
  CreateCampaignResponse,
} from '../models/DialerCampaign';

const API_URL = process.env.REACT_APP_TWILIO_INTEGRATION_SERVICE_API_URL;
const headers = { 'x-api-key': process.env.REACT_APP_TWILIO_INTEGRATION_SERVICE_API_KEY ?? '' };

/**
 * `poolId` opcional: omitido, o backend resolve para o pool default — que é
 * exatamente o comportamento anterior aos pools. Um `poolId` fora do registry
 * do backend é recusado com 422 na criação.
 */
export const createDialerCampaign = async (
  name: string,
  numbers: DialerCampaignContactInput[],
  poolId?: string
): Promise<CreateCampaignResponse> => {
  const { data } = await axios.post(
    `${API_URL}/dialer/campaigns`,
    { name, numbers, ...(poolId ? { poolId } : {}) },
    { headers }
  );
  return data;
};

export const getDialerPools = async (): Promise<DialerPool[]> => {
  const { data } = await axios.get(`${API_URL}/dialer/pools`, { headers });
  return data;
};

export const getDialerCampaigns = async (): Promise<DialerCampaign[]> => {
  const { data } = await axios.get(`${API_URL}/dialer/campaigns`, { headers });
  return data;
};

export const getDialerCampaign = async (campaignId: string): Promise<DialerCampaign> => {
  const { data } = await axios.get(`${API_URL}/dialer/campaigns/${campaignId}`, { headers });
  return data;
};

export const patchDialerCampaign = async (
  campaignId: string,
  status: 'paused' | 'running'
): Promise<void> => {
  await axios.patch(`${API_URL}/dialer/campaigns/${campaignId}`, { status }, { headers });
};
